export default __webpack_public_path__ + "static/media/done.a564ef3e.svg";